export const categoryList = [
  {
    slug: "entertainment",
    name: "娱乐八卦",
    icon: "ri-fire-line",
    description: "聚光灯下的最新动向，第一时间跟进讨论度最高的热点话题。",
    count: 168,
  },
  {
    slug: "stars",
    name: "明星动向",
    icon: "ri-star-line",
    description: "行程、官宣与新作消息，关注你喜欢的那位最近在忙什么。",
    count: 124,
  },
  {
    slug: "variety",
    name: "综艺热点",
    icon: "ri-live-line",
    description: "名场面复盘与节目走向分析，不错过任何一个出圈瞬间。",
    count: 96,
  },
  {
    slug: "film-tv",
    name: "影视剧集",
    icon: "ri-movie-2-line",
    description: "剧集、电影的口碑与幕后，追剧党的集中讨论区。",
    count: 142,
  },
  {
    slug: "influencer",
    name: "网络红人",
    icon: "ri-vidicon-line",
    description: "内容创作者的爆款逻辑与幕后故事，看懂流量背后的原因。",
    count: 88,
  },
  {
    slug: "fashion",
    name: "时尚红毯",
    icon: "ri-shirt-line",
    description: "红毯造型与品牌动态盘点，从穿搭细节里读出风格变化。",
    count: 73,
  },
];

export const hotList = [
  { rank: 1, keyword: "热播剧收官夜即兴互动", heat: "982 万", trend: "up", category: "影视剧集", linkId: "a01" },
  { rank: 2, keyword: "音乐节暴雨返场加唱", heat: "856 万", trend: "up", category: "综艺热点", linkId: "a02" },
  { rank: 3, keyword: "新综艺素人嘉宾坦白", heat: "743 万", trend: "new", category: "综艺热点", linkId: "a03" },
  { rank: 4, keyword: "盛典红毯造型盘点", heat: "698 万", trend: "down", category: "时尚红毯", linkId: "a04" },
  { rank: 5, keyword: "实力派演员新剧阵容", heat: "624 万", trend: "up", category: "影视剧集", linkId: "a05" },
  { rank: 6, keyword: "演唱会门票三秒售罄", heat: "587 万", trend: "up", category: "明星动向", linkId: "a06" },
  { rank: 7, keyword: "博主花絮播放破亿", heat: "531 万", trend: "new", category: "网络红人", linkId: "a07" },
  { rank: 8, keyword: "综艺即兴表演名场面", heat: "492 万", trend: "same", category: "综艺热点", linkId: "a08" },
  { rank: 9, keyword: "电影路演主创回应争议", heat: "458 万", trend: "up", category: "影视剧集", linkId: "a09" },
  { rank: 10, keyword: "新专辑先行曲风格转变", heat: "416 万", trend: "down", category: "明星动向", linkId: "a10" },
  { rank: 11, keyword: "恋综结局反转引逐帧分析", heat: "384 万", trend: "up", category: "综艺热点", linkId: "a11" },
  { rank: 12, keyword: "品牌官宣新代言人", heat: "352 万", trend: "new", category: "时尚红毯", linkId: "a12" },
];

export const faqList = [
  {
    question: "热搜吃瓜的内容多久更新一次？",
    answer:
      "首页的热搜榜与动态流会在工作日持续滚动更新，通常每个小时都会补充新一轮讨论度上升的话题，遇到大型活动或突发事件时会加密更新频率。",
  },
  {
    question: "网站上的内容主要来自哪里？",
    answer:
      "内容由编辑团队根据公开讨论热度整理与撰写，热点排序参考各平台的公开讨论量。我们只做信息梳理与观点呈现，不制造未经证实的消息。",
  },
  {
    question: "为什么有些热搜会突然从榜上消失？",
    answer:
      "热度榜是根据实时讨论量动态排序的，当某个话题的讨论量回落，它的排名自然会被后起的话题取代。榜单只反映当下的关注度，并不代表事件已经结束。",
  },
  {
    question: "可以只看某一位明星或某一个话题吗？",
    answer:
      "可以。你可以在资讯列表页选择对应的分类，或直接使用顶部搜索框输入关键词，页面会筛选出与之相关的内容。",
  },
  {
    question: "热搜的热度值是怎么计算出来的？",
    answer:
      "热度值综合了话题的讨论量、增长速度和参与人数三个维度，经过归一化处理后换算成便于阅读的分数。它只用于排序参考，不代表任何官方数据。",
  },
  {
    question: "浏览记录会被保存吗？",
    answer:
      "当前版本不会保存你的个人浏览记录，所有筛选与搜索都在本地完成。后续如果推出收藏功能，我们会在功能上线前明确说明数据的使用方式。",
  },
];

export const testimonialList = [
  {
    name: "阿柚",
    role: "追剧常驻选手",
    content:
      "最满意的是不用自己一个个平台去翻，打开首页就知道今天大家都在聊什么，榜单排序也挺准，省了不少时间。",
  },
  {
    name: "老周",
    role: "通勤路上刷一刷",
    content:
      "地铁上十分钟就能把当天的热点过一遍，条目写得清楚，不用点进去也能知道大概发生了什么。",
  },
  {
    name: "小林",
    role: "综艺内容爱好者",
    content:
      "名场面复盘那块做得挺用心，会把镜头和节奏拆开讲，看完再回去重看一遍确实能看出不一样的东西。",
  },
  {
    name: "Momo",
    role: "资讯重度用户",
    content:
      "分类做得很细，想追某个方向的内容直接切分类就行，不用在信息流里大海捞针，这点很加分。",
  },
];

export const siteInfo = {
  name: "热搜吃瓜",
  slogan: "紧跟热搜节奏，不错过每一个正在发生的现场",
  description:
    "热搜吃瓜是一个持续追踪当日热点与娱乐动态的中文资讯门户，按热度滚动更新，帮你在第一时间掌握最新进展与网友热议。",
  email: "hi@resouguan.cn",
  weibo: "@热搜吃瓜",
  wechat: "resouguan",
  updatedAt: "2026-09-10 09:30",
};